// 检查纬度是否规范
export function checkLatitude(text) {
    // var reg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/
    // let reg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,15}|90\.0{0,6}|[0-8]?\d{1}|90)$/;

    // eslint-disable-next-line no-useless-escape
    let reg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,15}|90\.0{0,15}|[0-8]?\d{1}|90)$/;
    return reg.test(text);
}

// 检查经度是否规范
export function checkLongitude(text) {
    // var reg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/

    // let reg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,15})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/;

    // eslint-disable-next-line operator-linebreak
    let reg =
        // eslint-disable-next-line no-useless-escape
        /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,15})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,15}|180)$/;
    return reg.test(text);
}

/**
 * 校验手机号码
 *
 */
export function checkMobile(text) {
    /**
     * 中国电信号段  133、153、173、177、180、181、189、190、191、193、199
     * 中国联通号段 130、131、132、145、155、156、166、167、171、175、176、185、186、196
     * 中国移动号段 134(0-8)、135、136、137、138、139、1440、147、148、150、151、152、157、158、159、172、178、182、183、184、187、188、195、197、198
     * 中国广电号段 192
     * 其他号段  14号段部分为上网卡专属号段：中国联通145，中国移动147，中国电信149
     * 虚拟运营商：
     * 电信：1700、1701、1702、162
     *移动：1703、1705、1706、165
     *联通：1704、1707、1708、1709、171、167
     *卫星通信：1349、174
     *物联网：140、141、144、146、148
     * */
    let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    return reg.test(text);
}

/**
 * 校验座机号码
 *
 */
export function checkTelPhone(text) {
    let reg = /^(0\d{2,3})-?(\d{7,8})$/;
    return reg.test(text);
}
